import React, { useEffect, useState } from 'react';
import { Button, Dropdown, MenuProps, Table, Menu, Modal } from 'antd';
import { DeleteOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import type { ColumnType } from 'antd/es/table';

import { AdminRoutes } from '../../../_router/admin.routes';
import {
  AiChatSettingsPerUserService,
  i18n,
  NavigationService,
} from '../../../../../common';

function AiChatSettingsPerUserTablePageComponent() {
  const [aiChatSettings, setAiChatSettings] = useState<TableType[]>([]);

  useEffect(() => {
    fetchAiChatSettings();
  }, []);

  const fetchAiChatSettings = () => {
    AiChatSettingsPerUserService.getAll().subscribe((response) => {
      const { data, included } = response;
      const tableData: TableType[] = data.map((item) => {
        const getLimitStatus = (limit: number | null) => {
          if (limit === 0) return 'ISKLJUČENO';
          if (limit && limit > 0) return `${limit}`;
          return 'NEOGRANIČENO';
        };

        const user = included.find((user) => user.id === item.relationships.user.data.id);

        const userName = user!.attributes.name;
        const organizationName = user!.attributes.organizationName;
        const questionNumber = getLimitStatus(item.attributes.questionNumber);

        return {
          id: item.id!,
          userName,
          organizationName,
          questionNumber,
        };
      });
      setAiChatSettings(tableData);
    });
  };

  const getActions = (record: TableType) => {
    const items: MenuProps['items'] = [
      {
        label: 'Izbriši',
        key: '4',
        icon: <DeleteOutlined />,
        onClick: () => deleteItem(record),
      },
    ];
    return items;
  };

  const columns: ColumnType<TableType>[] = [
    {
      title: 'Ime korisnika',
      key: 'userName',
      render: (text: TableType) => {
        return <span>{text.userName}</span>;
      },
    },
    {
      title: 'Organizacija',
      key: 'organizationName',
      render: (text: TableType) => {
        return <span>{text.organizationName}</span>;
      },
    },
    {
      title: 'Broj pitanja',
      key: 'questionNumber',
      render: (text: TableType) => {
        return <span>{text.questionNumber}</span>;
      },
    },

    {
      title: '',
      width: 48,
      render: (record: TableType) => (
        <Dropdown.Button
          type="link"
          overlay={<Menu items={getActions(record)} />}
          onClick={() => NavigationService.navigate(AdminRoutes.AI_CHAT_SETTINGS_PER_USER.fullPath + '/' + record.id)}
        >
          Uredi
        </Dropdown.Button>
      ),
    },
  ];

  const handleAdd = () => {
    NavigationService.navigate(AdminRoutes.AI_CHAT_SETTINGS_PER_USER.fullPath + '/new');
  };

  const deleteItem = (record: TableType) => {
    Modal.confirm({
      title: 'Da li ste sigurni da želite izbrisati ovu postavku?',
      icon: <ExclamationCircleOutlined />,
      content: 'Nije moguće vratiti postavku nakon brisanja.',
      okText: 'Da',
      cancelText: 'Ne',
      onOk: () => {
        AiChatSettingsPerUserService.delete(record.id!).subscribe(() => {
          setAiChatSettings(aiChatSettings.filter((item) => item.id !== record.id));
        });
      },
    });
  };

  return (
    <div className="ai-chat-settings-page w100-h100">
      <div className="action-container">
        {/* <div className="title">AI Chat postavke</div> */}
        <div></div>
        <Button type="primary" onClick={handleAdd}>
          Dodaj
        </Button>
      </div>

      <Table
        dataSource={aiChatSettings}
        columns={columns}
        pagination={false}
        rowKey={(record) => record.id?.toString() ?? ''}
        locale={{
          emptyText: i18n.t('common.noData'),
          triggerDesc: i18n.t('common.sortDesc'),
          triggerAsc: i18n.t('common.sortAsc'),
          cancelSort: i18n.t('common.cancelSort'),
          filterReset: i18n.t('common.reset'),
        }}
      />
    </div>
  );
}

export default AiChatSettingsPerUserTablePageComponent;

interface TableType {
  id: number;
  userName: string;
  organizationName: string;
  questionNumber: string;
}
